import {Base} from "@/api/Base"

export class PaymentAdd extends Base {
    path = "payment/add"
}